import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router';
import { StoreState } from '@ui/store/rootReducer';
import { Button, Icon, Upload } from 'antd';
import { LoadableContent } from '@ui/components';
import { countriesSelectors } from '../';
import * as actions from '../services/actions';
import CountriesList from '../components/CountriesList';

import './countries.less';
import { getApiUrl } from '../../../utils/config';

interface StateToProps {
  loading: boolean;
  countries: any[];
}

interface DispatchToProps {
  onLoadCountries: () => void;
}

type Props = StateToProps & DispatchToProps & RouteComponentProps;

class Countries extends React.PureComponent<Props> {
  componentDidMount(): void {
    const { onLoadCountries } = this.props;
    onLoadCountries();
  }

  handleClickCountry = (country: any) => {
    const { history } = this.props;
    history.push(`countries/${country.id}/stores`);
  };

  handleBeforeUpload = (file: any) => {
    console.log(file);

    return true;
  };

  render(): React.ReactNode {
    const { loading, countries } = this.props;
    return (
      <LoadableContent loading={loading}>
        <div className="countries-page__content">
          <CountriesList
            countries={countries}
            onClick={this.handleClickCountry}
          />
        </div>
        <div className="load-file-panel">
          <Upload
            beforeUpload={this.handleBeforeUpload}
            action={`${getApiUrl()}/file/load`}
          >
            <Button className="load-file-button" type="primary">
              <Icon type="upload" />
              Загрузить файл
            </Button>
          </Upload>
        </div>
        <div className="load-file-panel">
          <a href={`${getApiUrl()}/focus`} className="download-focus">
            <Icon type="download" />
            <span>Скачать фокус</span>
          </a>
        </div>
      </LoadableContent>
    );
  }
}

const mapStateToProps = (state: StoreState): StateToProps => ({
  countries: countriesSelectors.getCountries(state),
  loading: countriesSelectors.getLoading(state),
});

const mapDispatchToProps = {
  onLoadCountries: actions.countriesRequsted,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Countries),
);



// WEBPACK FOOTER //
// ./src/scenes/Countries/containers/Countries.tsx